const CyprusSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111279)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FCFCFC"
      />
      <path
        d="M31.3044 17.3916C30.6957 17.3916 29.9421 17.3916 28.6957 17.3916C28.6957 22.1941 24.8024 26.0872 20.0001 26.0872C15.1975 26.0872 11.3045 22.1941 11.3045 17.3916C10.4638 17.3916 9.53627 17.3916 8.6958 17.3916C8.6958 22.5646 12.1705 26.9261 16.9135 28.2693C16.3935 29.2571 16.4727 30.5008 17.2155 31.4278C18.1911 30.6458 19.2012 29.8364 20.0581 29.1498C20.9149 29.8364 21.9251 30.6459 22.9006 31.4278C23.6508 30.4916 23.7246 29.2322 23.1874 28.2396C27.8784 26.8634 31.3044 22.5279 31.3044 17.3916Z"
        fill="#6DA544"
      />
      <path
        d="M13.0435 16.5215C13.0435 16.5215 13.0435 20.8693 17.3913 20.8693L18.2608 21.7389H19.9999C19.9999 21.7389 20.8695 19.1302 22.6086 19.1302C22.6086 19.1302 22.6086 17.3911 24.3478 17.3911C26.0869 17.3911 26.9564 17.3911 26.9564 17.3911C26.9564 17.3911 26.0869 13.9128 30.4347 11.3041L28.6956 10.4346C28.6956 10.4346 22.6086 14.7824 18.2608 13.9129V15.652H16.5217L15.6521 14.7825L13.0435 16.5215Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111279">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CyprusSvg;
